<template>
  <div class="abstract-card">
    <div class="header">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractGeneralSettings.notificationCollect')}}</div>
      <span>{{$t('components.abstract.tabs.abstractGeneralSettings.notificationCollectMsg')}}</span>
    </div>
    <el-row :gutter="10" v-if="form.generalSettings">
      <el-col :span="24" class="mt-3">
        <el-button-group class="d-flex">
          <el-button size="mini" class="w-100" @click="form.generalSettings.type = 0" round :type="form.generalSettings.type == 0 ? 'primary' : 'default'">{{$t('components.abstract.tabs.abstractGeneralSettings.textUpload')}}</el-button>
          <el-button size="mini" class="w-100" @click="form.generalSettings.type = 1" round :type="form.generalSettings.type == 1 ? 'primary' : 'default'">{{$t('components.abstract.tabs.abstractGeneralSettings.fileUpload')}}</el-button>
        </el-button-group>
      </el-col>
      <el-col :span="24" class="mt-2">
        <el-row :gutter="10">
          <el-col :span="8">
            <div class="registerform-input-container mt-2">
              <div class="title">
                <div>
                  <label>{{$t('components.abstract.tabs.abstractGeneralSettings.label')}}</label>
                  <el-tooltip content="Content" placement="bottom">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
              </div>
              <el-input v-model="form.generalSettings.label"></el-input>
              <span class="error">{{ $errorMessage('generalSettings.Label', validationErrors) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="registerform-input-container mt-2">
              <div class="title">
                <div>
                  <label>{{$t('components.abstract.tabs.abstractGeneralSettings.placeholder')}}</label>
                  <el-tooltip content="Content" placement="bottom">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
              </div>
              <el-input v-model="form.generalSettings.placeholder"></el-input>
              <span class="error">{{ $errorMessage('generalSettings.Placeholder', validationErrors) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="registerform-input-container mt-2">
              <div class="title">
                <div>
                  <label>{{$t('components.abstract.tabs.abstractGeneralSettings.hint')}}</label>
                  <el-tooltip content="Content" placement="bottom">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
              </div>
              <el-input v-model="form.generalSettings.hint"></el-input>
              <span class="error">{{ $errorMessage('generalSettings.Hint', validationErrors) }}</span>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <transition name="el-fade-in" mode="out-in">
        <el-col :span="24" v-if="form.generalSettings.type == 0" key="text-upload">
          <el-row>
            <el-col :span="24" class="mt-3">
              <div class="custom-set-container" :class="form.generalSettings.enableWordLimit ? 'sactive' : ''">
                <div class="custom-set-inner">
                  <i class="fa" :class="form.generalSettings.enableWordLimit ? 'fa-tags' : 'fa-tags'"></i>
                  <div class="custom-set-info">
                    <label>
                      {{$t('components.abstract.tabs.abstractGeneralSettings.wordLimit')}}
                      <el-tooltip content="Content" placement="bottom">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </label>
                    <span>{{$t('components.abstract.tabs.abstractGeneralSettings.wordLimitMsg')}}</span>
                  </div>
                </div>
                <div class="custom-set-actions fend">
                  <el-switch v-model="form.generalSettings.enableWordLimit"></el-switch>
                </div>
                <div class="custom-set-actions fcenter mt-3" v-show="form.generalSettings.enableWordLimit">
                  <el-row :gutter="10" class="w-100">
                    <el-col :span="12">
                      <div class="registerform-input-container mt-2">
                        <div class="title">
                          <div>
                            <label>{{$t('components.abstract.tabs.abstractGeneralSettings.minChar')}}</label>
                            <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                        </div>
                        <el-input-number v-model="form.generalSettings.minCharAllowed"></el-input-number>
                        <span class="error">{{ $errorMessage('generalSettings.Hint', validationErrors) }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="registerform-input-container mt-2">
                        <div class="title">
                          <div>
                            <label>{{$t('components.abstract.tabs.abstractGeneralSettings.maxChar')}}</label>
                            <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                        </div>
                        <el-input-number v-model="form.generalSettings.maxCharAllowed"></el-input-number>
                        <span class="error">{{ $errorMessage('generalSettings.Hint', validationErrors) }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="custom-set-container" :class="form.generalSettings.allowImageUpload ? 'sactive' : 'spassive'">
                <div class="custom-set-inner">
                  <i class="fa" :class="form.generalSettings.allowImageUpload ? 'fa-images' : 'fa-eye-slash'"></i>
                  <div class="custom-set-info">
                    <label>
                      {{$t('components.abstract.tabs.abstractGeneralSettings.allowImageUpload')}}
                      <el-tooltip content="Content" placement="bottom">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </label>
                    <span>{{$t('components.abstract.tabs.abstractGeneralSettings.allowImageUploadMsg')}}</span>
                  </div>
                </div>
                <div class="custom-set-actions fend">
                  <el-switch v-model="form.generalSettings.allowImageUpload"></el-switch>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="24" v-else key="file-upload">
          <el-row :gutter="10" class="mt-3">
            <el-col :span="8">
              <div class="registerform-input-container mt-2">
                <div class="title">
                  <div>
                    <label>{{$t('components.abstract.tabs.abstractGeneralSettings.maxSize')}}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-input-number class="w-100" :min="1" :max="5" v-model="form.generalSettings.maxFileSizeMB"></el-input-number>
                <span class="error">{{ $errorMessage('submissionTopicsTitle', validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="title">
                  <div class="title-container">
                    <label>{{$t('components.abstract.tabs.abstractGeneralSettings.allowFile')}}</label>
                  </div>
                </div>
                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isImageIndeterminate" v-model="imageAll" @change="handleCheckAllImage">{{$t('components.abstract.tabs.abstractGeneralSettings.imgFile')}}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="form.generalSettings.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find((x) => x.title == 'ImageFileType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isTextIndeterminate" v-model="textAll" @change="handleCheckAllText">{{$t('components.abstract.tabs.abstractGeneralSettings.textFile')}}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="form.generalSettings.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find((x) => x.title == 'TextFileType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isSpeadSheetTypeIndeterminate" v-model="spreadSheetAll" @change="handleCheckAllSpeadSheetType">{{$t('components.abstract.tabs.abstractGeneralSettings.spreadsheetFile')}}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="form.generalSettings.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find((x) => x.title == 'SpeadSheetType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isPresentationTypeIndeterminate" v-model="presentationAll" @change="handleCheckAllPresentationType">{{$t('components.abstract.tabs.abstractGeneralSettings.presentationFile')}}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="form.generalSettings.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find((x) => x.title == 'PresentationFileType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>

                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isCompressedTypeIndeterminate" v-model="compressedAll" @change="handleCheckAllCompressedType">{{$t('components.abstract.tabs.abstractGeneralSettings.notificationcompressedFileCollect')}}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="form.generalSettings.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find((x) => x.title == 'CompressedFileType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </transition>
    </el-row>

    <div class="bottom mt-3 d-flex justify-content-end">
      <el-button type="primary" size="mini" round :loading="loading" @click="saveAbstractGeneralSettings">{{$t('components.abstract.tabs.abstractGeneralSettings.save')}}</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: ['data'],
  data() {
    return {
      axios,
      loading: false,
      timeout: null,
      form: null,
      imageAll: false,
      textAll: false,
      spreadSheetAll: false,
      presentationAll: false,
      compressedAll: false,
      isImageIndeterminate: true,
      isTextIndeterminate: true,
      isSpeadSheetTypeIndeterminate: true,
      isPresentationTypeIndeterminate: true,
      isCompressedTypeIndeterminate: true,
      validationErrors: [],
      editorOption: {
        modules: {
          toolbar: {
            container: [['bold', 'italic', 'underline', 'strike'], [{ color: [] }, { background: [] }], ['clean'], ['link', 'image', 'video']],
            handlers: {
              image: () => {
                this.selectLocalImage();
              },
            },
          },

          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value,
          },

          resize: {
            modules: ['Resize'],
          },
        },
      },
    };
  },
  methods: {
    handleCheckAllImage(val) {
      if (val == true) {
        this.getEnums
          .find((x) => x.title == 'ImageFileType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data == -1) {
              this.form.generalSettings.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find((x) => x.title == 'ImageFileType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data != -1) {
              this.form.generalSettings.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isImageIndeterminate = false;
    },
    handleCheckAllText(val) {
      if (val == true) {
        this.getEnums
          .find((x) => x.title == 'TextFileType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data == -1) {
              this.form.generalSettings.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find((x) => x.title == 'TextFileType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data != -1) {
              this.form.generalSettings.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isTextIndeterminate = false;
    },
    handleCheckAllSpeadSheetType(val) {
      if (val == true) {
        this.getEnums
          .find((x) => x.title == 'SpeadSheetType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data == -1) {
              this.form.generalSettings.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find((x) => x.title == 'SpeadSheetType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data != -1) {
              this.form.generalSettings.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isSpeadSheetTypeIndeterminate = false;
    },
    handleCheckAllPresentationType(val) {
      if (val == true) {
        this.getEnums
          .find((x) => x.title == 'PresentationFileType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data == -1) {
              this.form.generalSettings.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find((x) => x.title == 'PresentationFileType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data != -1) {
              this.form.generalSettings.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isPresentationTypeIndeterminate = false;
    },
    handleCheckAllCompressedType(val) {
      if (val == true) {
        this.getEnums
          .find((x) => x.title == 'CompressedFileType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data == -1) {
              this.form.generalSettings.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find((x) => x.title == 'CompressedFileType')
          .enums.map((x) => {
            var data = this.form.generalSettings.allowedExtensions.findIndex((y) => y == x.displayName);
            if (data != -1) {
              this.form.generalSettings.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isCompressedTypeIndeterminate = false;
    },
    saveAbstractGeneralSettings() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = true;

      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch('abstractUpdateGeneralSettings', this.form);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
  },
  created() {
    this.form = this.data;
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
  },
  watch: {
    data: function() {
      if (this.data != undefined && this.data != null) {
        this.form = this.data;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.authors-card {
  padding: 1rem !important;
  border: 1px solid #ccc;
}
.abstract-card {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  padding: 1rem;

  & > .header {
    color: black;
    & > .title {
      display: flex;
      font-weight: bold;
      justify-content: space-between;
      align-items: center;
    }
    span {
      font-weight: 400;
    }
  }
}
.question-checkbox-container {
  display: flex;
  margin-bottom: 1rem;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  .el-checkbox {
    margin: 0;
  }
  & > .question-checkbox-title {
    display: flex;
    width: 200px;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-start;
  }
  & > .list-checkbox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 0.5rem;
    align-items: center;
  }
  .question-custom-checkbox-group {
    display: flex;
    gap: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/abstract/tabs/AbstractGeneralSettings.vue